export default "__VITE_ASSET__DAapwseB__"